
import React from "react";
import PropTypes from "prop-types";

// components

export default function InfoAreaUser({ image, name }) {
  return (
    <div className="px-1">
      <img
        alt="..."
        src={image}
        className=" mx-auto max-w-64-px"
      />
      <div className="pt-1 text-center">
        <h5 className="text-sm">{name}</h5>
      </div>
    </div>
  );
}
InfoAreaUser.defaultProps = {
  socialLinks: [],
};
InfoAreaUser.propTypes = {
  // src of the image
  image: PropTypes.string.isRequired,
  name: PropTypes.string,
  jobTitle: PropTypes.string,
  socialLinks: PropTypes.arrayOf(
    // this will generate an anchor with target blank to the given link
    PropTypes.shape({
      icon: PropTypes.oneOf(["facebook", "twitter", "instagram", "dribble"]),
      link: PropTypes.string,
    })
  ),
};
